import request from '../../utils/request'
import config from '../../../config/config'
// const baseURL = 'http://localhost:3013'
const baseURL = config.baseUrl;

//  信息新增
export function choujiangquanAdd (data) {
  return request({
    url: baseURL + 'choujiangquan/add',
    method: 'post',
    data: data
  })
}
//  信息查询
export function choujiangquanList (data) {
  return request({
    url: baseURL + 'choujiangquan/list',
    method: 'post',
    data: data
  })
}
//  信息删除
export function choujiangquanDelete (data) {
  return request({
    url: baseURL + 'choujiangquan/delete',
    method: 'post',
    data: data
  })
}
//  信息删除
export function choujiangquanUpdate (data) {
  return request({
    url: baseURL + 'choujiangquan/update',
    method: 'post',
    data: data
  })
}

//  信息查询
export function choujiangRecordList (data) {
  return request({
    url: baseURL + 'choujiangRecord/list',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/choujiangquan/index.js